import { getDeviceType } from '../helper';

const MULTIPLE_SELECTS = document.querySelectorAll('select[multiple="multiple"]');
const DEVICE = getDeviceType();

const handleChange = (e) => {
	const el = e.currentTarget;
	el.options[0].selected = false;

	if (el.selectedOptions.length >= 1) el.options[0].selected = false;
	else el.options[0].selected = true;
}

if (DEVICE === 'mobile') {
	MULTIPLE_SELECTS.forEach((select) => {
		const defaultOption = document.createElement('option');
		defaultOption.disabled = true;
		defaultOption.selected = true;
		defaultOption.innerHTML = 'Auswählen';

		select.insertBefore(defaultOption, select.firstChild);
		select.style.height = '50px';

		select.addEventListener('change', (event) => handleChange(event));
	})
}